import {type ReactNode} from 'react'
import {grid} from '~/design-system/foundations'

export const WYSIWYG_CONTAINER_ID = 'wysiwyg'

const HgArticleWYSIWYGContainer = ({children}: {children: ReactNode}) => {
  return (
    <div className="w-full" id={WYSIWYG_CONTAINER_ID}>
      <div
        className={grid({
          className:
            'mx-auto mt-s7 [&_ol_+_ul]:my-4 md:[&_ol_+_ul]:my-8 lg:[&_ol_+_ul]:my-12',
        })}
      >
        {children}
      </div>
    </div>
  )
}

export default HgArticleWYSIWYGContainer
